export const alkymetricsBaseURL =
  process.env.RAZZLE_RUNTIME_ENV === 'production'
    ? 'https://alkymetrics.com.ar/api/'
    : 'https://test.alkymetrics.com.ar/api/';
export const alkymindBaseURL = process.env.RAZZLE_RUNTIME_ALKYMIND_URL;
export const alkymetricsV2BaseURL = process.env.RAZZLE_RUNTIME_ALKYMETRICS_V2_URL;
export const screeningsBaseURL = process.env.RAZZLE_RUNTIME_SCREENINGS_URL;
export const alkycheatBaseUrl = process.env.RAZZLE_RUNTIME_ALKYCHEAT_URL;
export const n8nBaseURL = process.env.RAZZLE_RUNTIME_N8N_URL;
